export default __webpack_public_path__ + "static/media/payment.1920021d.svg";